export default "__VITE_ASSET__CrfXQELV__"